import { createAction } from "redux-actions";
import {  FIND_CREDITS, GET_INITIAL_CREDITS, GET_ADITIONAL_CREDITS, GET_TYPE_CREDITS } from "../constants";
import { feathersCreateData } from "../services";

export const getCredits = createAction(FIND_CREDITS, (data) => feathersCreateData('core-server', 
    {
        service: 'LOANS', 
        func: 'GET_LOANS_DETAIL_TABLE',
        data
    }
)() )

export const getInfoCredits = createAction(GET_INITIAL_CREDITS, (data) => feathersCreateData('core-server', 
    {
        service: 'LOANS', 
        func: 'GET_LOANS_INFO',
        data
    }
)() )

export const getAditionalCredits = createAction(GET_ADITIONAL_CREDITS, (data) => feathersCreateData('core-server', 
    {
        service: 'LOANS', 
        func: 'GET_LOANS_ADITIONAL_INFO',
        data
    }
)() )

export const getTypeCredits = createAction(GET_TYPE_CREDITS, (data) => feathersCreateData('core-server', 
    {
        service: 'LOANS', 
        func: 'GET_LOANS_TYPE',
        data
    }
)() )
